import { StyledStack } from 'app/components/Stack';
import {
  selectInfoUser,
  selectTranslations,
} from 'app/pages/App/slice/selectors';
import {
  GET_LIST_PAYMENT_METHOD,
  useCatalogSlice,
} from 'app/pages/Catalog/slice';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { BP_TYPE } from 'utils/constants';

const PaymentMethod = ({ onChangeMethod, ...props }) => {
  const dispatch = useDispatch();
  useCatalogSlice();
  const translations = useSelector(selectTranslations);
  const listPaymentMethod = useSelector(
    (state: any) => state?.catalog?.listPaymentMethod,
  );
  const [paymentMethod, setPaymentMethod] = useState<number | undefined>(
    props?.paymentMethodDefault,
  );

  const handleChangePaymentMethod = value => {
    const newPayment = onChangeMethod(value);
    setPaymentMethod(newPayment);
  };
  const infoUser = useSelector(selectInfoUser);
  useEffect(() => {
    if (paymentMethod) return;
    if (props?.paymentMethodDefault) {
      setPaymentMethod(props?.paymentMethodDefault);
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listPaymentMethod, paymentMethod, props?.paymentMethodDefault]);
  useEffect(() => {
    if (listPaymentMethod?.length > 0 && paymentMethod) {
      const findPaymentMethodDefault = listPaymentMethod.find(
        (item: any) => item.id === paymentMethod,
      );
      if (_.isEmpty(findPaymentMethodDefault)) {
        setPaymentMethod(listPaymentMethod[0].id);
      }
    }
  }, [listPaymentMethod, paymentMethod]);

  // useEffect(() => {
  //   if (listPaymentMethod?.length > 0) return;
  //   const isProxyBuyer =
  //     (infoUser?.businessPartner as any)?.bpType === BP_TYPE.PROXY_BUYER;
  //   dispatch(
  //     GET_LIST_PAYMENT_METHOD({
  //       ticketType: sessionStorage.getItem('ticketType'),
  //       ...(isProxyBuyer && { bpAllocatedDebt: props?.bpAllocatedDebt }),
  //     }),
  //   );
  // }, [dispatch, listPaymentMethod?.length]);

  return (
    <StyledStack rowGap={'5px'} columnGap={'16px'} direction={'column'}>
      {listPaymentMethod?.length > 0 && (
        <StyledStack
          style={{ flexWrap: 'wrap' }}
          rowGap={'8px'}
          columnGap={'8px'}
        >
          {listPaymentMethod.map((method, index) => {
            const isPng = method?.image?.original
              ?.toLowerCase()
              .endsWith('.png');
            return (
              <StyledStack
                key={index}
                style={{
                  borderRadius: 10,
                  border: '1px solid',
                  borderColor:
                    method.id === paymentMethod ? '#E92127' : '#D9D9D9',
                  transition: 'border-color 0.2s ease-in-out',
                  height: 68,
                  padding: '0 10px',
                  maxWidth: 210,
                  width: 'fit-content',
                }}
                alignItem={'center'}
                onClick={() => handleChangePaymentMethod(method?.id)}
              >
                <img
                  draggable={false}
                  alt={method?.name}
                  src={method?.image?.original}
                  style={{
                    objectFit: 'contain',
                    height: isPng ? '100%' : 'auto',
                  }}
                />
              </StyledStack>
            );
          })}
        </StyledStack>
      )}
      <div className="d-flex flex-wrap">
        {listPaymentMethod?.find(
          val => val.id === paymentMethod && val?.detail?.validFrom,
        ) && (
          <p style={{ fontSize: 14 }}>
            {` ${
              translations
                ? translations['b2b.txt.payment_notice_1']
                    ?.replace(
                      '${payment}',
                      listPaymentMethod?.find(val => val.id === paymentMethod)
                        ?.detail?.name,
                    )
                    ?.replace(
                      '${hour_from}',
                      listPaymentMethod?.find(val => val.id === paymentMethod)
                        ?.detail?.validFrom,
                    )
                    ?.replace(
                      '${hour_to}',
                      listPaymentMethod?.find(val => val.id === paymentMethod)
                        ?.detail?.validTo,
                    )
                : ''
            }`}
          </p>
        )}
        {listPaymentMethod?.find(
          val =>
            val.id === paymentMethod &&
            ['Payoo', 'VNPay'].includes(val?.detail?.code),
        ) && (
          <p style={{ fontSize: 14 }}>
            {`${translations ? translations['b2b.txt.visa-notice'] : ''}`}
          </p>
        )}
      </div>
    </StyledStack>
  );
};

export default PaymentMethod;
